module.exports = __webpack_public_path__ + "img/box-icon.d6a8594b.svg";